import React from "react";

export default function SectionDivider() {
  return (
    <div className="hk-section-divider-container" aria-hidden="true">
      <div className="hk-section-divider-line" />
      <div className="hk-section-divider-badge">
        <span className="hk-section-divider-diamond" />
      </div>
      <div className="hk-section-divider-line" />
    </div>
  );
}
